import TabRealisasiUpah from './TabRealisasiUpah';

export default TabRealisasiUpah;
